/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './HelpIcon.style';

import BaseIcon from 'src/shared/ui/component/icon/BaseIcon';

import svg from './help.svg';

type Props = {
  className?: string,
  title?: string,
};

const useStyles = createUseStyles(styles);

const HelpIcon = ({ className, title }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <BaseIcon
      className={classNames(classes.root, className)}
      svg={svg}
      title={title}
    />
  );
};

export default compose(React.memo)(HelpIcon);
